// src/App.js
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ChatProvider } from "./context/ChatContext";  // Add this import
import NavBar from "./components/NavBar";
import Hero from "./components/Hero";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Skills from "./components/Skills";
import Projects from "./components/Projects";
import Chat from "./components/Chat";
import AIChatbot from "./components/AIChatbot";  // ✅ Import AI Chatbot
import AdminChatInterface from "./components/AdminChat/AdminChatInterface";
import Login from "./components/AdminChat/Login";
import { useAuth } from "./context/AuthContext";

const LoadingScreen = () => (
    <div className="flex justify-center items-center h-screen bg-gray-900 text-white text-2xl">
        🚀 Loading Portfolio...
    </div>
);

const MainContent = ({ openAIChat }) => { // ✅ Accept openAIChat as a prop
    const { isAdmin } = useAuth();

    return (
        <main className="relative">
            {/* {!isAdmin && <Chat />} */}
            <Hero openAIChat={openAIChat} />
            <About />
            <Projects />
            <Skills />
            <Contact />
        </main>
    );
};

const AppContent = () => {
    const { isAdmin } = useAuth();
    const hideChatOnPages = ["/admin-chat", "/admin-login"];
    const [loading, setLoading] = useState(true);
    const [isAIChatOpen, setIsAIChatOpen] = useState(false);  // ✅ AI Chatbot State

    useEffect(() => {
        const timer = setTimeout(() => setLoading(false), 800);
        return () => clearTimeout(timer);
    }, []);

    if (loading) return <LoadingScreen />;

    return (
        <div className="relative min-h-screen bg-white dark:bg-gray-900 transition-all">
            <NavBar />
            <div className="relative z-20"> {/* Add this wrapper with z-index */}
                {!hideChatOnPages.includes(window.location.pathname) && !isAdmin && <Chat />}
                <Routes>
                    <Route path="/" element={<MainContent openAIChat={() => setIsAIChatOpen(true)} />} /> {/* ✅ Pass function */}
                    <Route path="/about" element={<About />} />
                    <Route path="/projects" element={<Projects />} />
                    <Route path="/skills" element={<Skills />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/admin-login" element={<Login />} />
                    <Route path="/admin-chat" element={<AdminChatInterface />} />
                </Routes>
            </div>
            <Footer className="relative z-30" /> {/* Add z-index to ensure footer stays above chat */}
            {/* ✅ AI Chatbot Pop-up (Globally Accessible) */}
            <AIChatbot isOpen={isAIChatOpen} onClose={() => setIsAIChatOpen(false)} />
        </div>
    );
};

const App = () => {
    return (
        <AuthProvider>
            <ChatProvider>
                <Router>
                    <AppContent />
                </Router>
            </ChatProvider>
        </AuthProvider>
    );
};

export default App;